import React from 'react';
import DSSpinner from '@elliemae/ds-basic/Spinner';
import { SpinnerContainer } from './renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../blockNames.js';

function RowsLoader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size;
  return /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(DSSpinner, {
    size: size
  }));
}

export default RowsLoader;
//# sourceMappingURL=RowsLoader.js.map
